import React from 'react';

export const DeleteInformationBlock = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="24" height="24" rx="4" fill="#EAEBED" />
            <path
                d="M15.3333 18.6666H8.66667C7.93029 18.6666 7.33333 18.0696 7.33333 17.3333V8.66659H6V7.33325H8.66667V6.66659C8.66667 5.93021 9.26362 5.33325 10 5.33325H14C14.7364 5.33325 15.3333 5.93021 15.3333 6.66659V7.33325H18V8.66659H16.6667V17.3333C16.6667 18.0696 16.0697 18.6666 15.3333 18.6666ZM8.66667 8.66659V17.3333H15.3333V8.66659H8.66667ZM10 6.66659V7.33325H14V6.66659H10ZM14 15.9999H12.6667V9.99992H14V15.9999ZM11.3333 15.9999H10V9.99992H11.3333V15.9999Z"
                fill="#757575"
            />
        </svg>
    );
};
